import React from 'react';

const InvestmentSection: React.FC = () => {
  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#FFFFFF] pt-20 pb-20">
              <div className="">
          <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-32 gap-14">
            {/* Top Left - Why Invest Text */}
            <div className="space-y-10 order-1">
              <h2 className="text-[25px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7 lg:text-left">
              Why Master Junior Mining Speculation?
              </h2>
              <div className="space-y-4 ">
                <p  className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0 text-justify">
                Junior mining stocks offer the <strong>potential for outsized returns</strong>, driven by discoveries or project advancements in commodities like gold, silver, lithium, copper, and uranium. However, their high volatility and 80–90% failure rate demand mining stock research of the highest caliber. At The Wealthy Miner, we combine mining market analysis with real-time mining stocks news to help you identify opportunities and mitigate risks. Our approach reflects the sophistication required to <strong>excel as a speculator, blending geological expertise, financial acumen, and strategic timing.</strong>
                </p>
              </div>
            </div>

            {/* Top Right - Person Examining Core Samples */}
            <div className="flex justify-center items-center order-2 h-full">
              <div className="relative w-full max-w-md xl:max-w-none h-full">
                <img 
                  src="/images/tent.webp" 
                  alt="Geologist examining core samples" 
                  className="w-full h-full rounded-r-[25px] object-cover"
                />
              </div>
            </div>

            {/* Bottom Left - Core Samples with Pickaxe */}
            <div className="flex justify-center items-center order-4 lg:order-3 h-full">
              <div className="relative w-full max-w-md xl:max-w-none h-full">
                <img 
                  src="/images/helicopter.webp" 
                  alt="Core samples with geological pickaxe" 
                  className="w-full h-full rounded-l-[25px] object-cover"
                />
              </div>
            </div>

            {/* Bottom Right - Robert's Insider Edge */}
            <div className="space-y-10 order-3 lg:order-4 mt-10 lg:mt-0">
              <h2 className="text-[25px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7 lg:text-left">
              Rob Bruggeman’s Expert Analysis
              </h2>
              <div className="space-y-4 ">
                <p  className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0 text-justify">
                With a proven track record of transforming early-stage companies into market leaders, Rob brings a <strong>disciplined framework to mining industry analysis</strong>. His expertise spans:
                <ul className="list-disc list-inside">
                  <li><strong>Geological Due Diligence:</strong> Interpreting NI 43-101 reports, drill results, and resource estimates to uncover high-potential projects.</li>
                  <li><strong>Financial Evaluation:</strong> Assessing cash runways, capital structures, and insider ownership to avoid dilution traps.</li>
                  <li><strong>Market Timing:</strong> Identifying catalysts like resource upgrades or acquisitions to capitalize on mining market trends.</li>
                </ul><br />
Through thorough research , Rob delivers actionable commentary and videos teaching you to evaluate management teams, jurisdictional risks, and commodity cycles with precision.
                </p>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
};

export default InvestmentSection;
